import { useLazyQuery, gql } from '@apollo/client';

const today = new Date().toISOString();

export function GetEducationArticles(tag, per_page, excluding_ids) {
    const query = gql`
        query ($tag: String, $per_page: Int, $excluding_ids: String) {
            EducationalarticleItems(sort_by: "first_published_at:desc", with_tag: $tag, per_page: $per_page, first_published_at_lt:"${today}", , excluding_ids: $excluding_ids) {
                total
                items {
                    id
                    uuid
                    full_slug
                    first_published_at
                    name
                    content {
                        hat
                        custom_hat
                        resume
                        featured_image {
                            filename
                            alt
                        }
                        authors {
                            fullSlug
                            name
                            content
                        }
                    }
                }
            }
        }
    `;

    const [getQuery, { loading, error, data }] = useLazyQuery(query, {
        variables: { tag, per_page, excluding_ids }
    });

    return { getQuery, loading, error, data };
}
